<template>
    <div class="section-link">
        <a :href="link">
            <img :src="image" :alt="alt">
            <div class="section-message" v-if="message"><a :href="link">{{ message }}</a>
            <div class="section-message-child"><slot></slot></div>
            </div>
        </a>
    </div>
</template>

<script>
    export default {
    	props: [
    		"link",
            "image",
            "alt",
            "message"
        ]
    }
</script>

<style lang="scss">
    @import "~foundation-sites/scss/foundation";
    aside.sidebar > .section-link {
        @include breakpoint(medium) {
            flex: calc(50% - 1rem) 0 0;
        }
    }
    .section-link {
        position: relative;
        &:hover {
            .section-message {
                @include breakpoint(medium) {
                    height: 100%;
                }
                @include breakpoint(large) {
                    transform: translate(-100%);
                }
            }
        }
    }
    .section-link img {
        display: block;
        width: 100%;
    }
    .section-message {
        transition: all 275ms, height 275ms;
        @include breakpoint(large) {
            transition: all 275ms ease-in-out, height 275ms linear 275ms;
        }
        bottom: 0;
        background: rgba(0, 0, 0, 0.75);
        color: #f9f9f9;
        width: 100%;
        padding: 1rem;
        font-size: 1.2rem;
        @include breakpoint(medium) {
            font-size: 1.4rem;
        }
        position: absolute;
        font-weight: bold;
        height: 3.3rem;
        overflow: hidden;
        z-index: 100;
        > a {
            width: 100%;
            text-align: center;
            display: block;
        }
        a {
            color: inherit;
            &:hover {
                color: lighten(#577f40,10%);
            }
        }
        &-child {
            font-size: 1.1rem;
            padding: 1rem;
            font-weight: normal;
            ul {
                list-style-position: outside;
            }
            li {
                margin-left: 2rem;
            }
            a {
                font-size: 1.1rem;
                padding: .4rem;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// section-link.vue?35568945